module.exports = __webpack_public_path__ + "static/media/pink_check.13b03982.svg";